import { galleryScrollToItem as scrollToItem } from './galleryScrollToItem';
import { initializeGlide } from './gallerySlideOrScroll';
import { galleryState as state } from './galleryState';

export const galleryScrollUpToUrlFotoParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fotoParam = urlParams.get('foto');
  let itemNumber = 0;

  if (fotoParam) {
    const fotoParamNumber = Number(fotoParam) - 1;
    const elementExists: HTMLElement | null = document.querySelector(
      `[data-gallery-item-position="${fotoParamNumber}"]`
    );

    if (fotoParamNumber) {
      itemNumber = elementExists ? fotoParamNumber : 0;
    }
  }

  if (state.getView() === 'slideOrScroll') {
    if (state.getIsDesktop()) {
      const glide = initializeGlide();
      if (glide) {
        glide.update({ animationDuration: 0 });
        glide.go(`=${itemNumber}`);
        glide.update({ animationDuration: 500 });
      }
    } else {
      scrollToItem({
        itemPosition: itemNumber,
      });
    }
  }

  state.setActiveItem(itemNumber);
};
